import { visit } from 'unist-util-visit';
import type { Element, Root } from 'hast';

/**
 * Re-points in-document links after sanitization.
 *
 * The sanitizer prefixes every `id` with `user-content-` to prevent DOM
 * clobbering, but it does not rewrite `href="#..."` fragments. Without this,
 * GFM footnote links and any author-written anchors would dangle.
 */
export default function rehypeFixFragmentLinks(options: { clobberPrefix?: string } = {}) {
  const prefix = options.clobberPrefix ?? 'user-content-';

  return (tree: Root) => {
    const ids = new Set<string>();

    visit(tree, 'element', (node: Element) => {
      const id = node.properties?.id;
      if (typeof id === 'string') ids.add(id);
    });

    visit(tree, 'element', (node: Element) => {
      if (node.tagName !== 'a') return;
      const href = node.properties?.href;
      if (typeof href !== 'string' || !href.startsWith('#')) return;

      const target = href.slice(1);
      if (target === '' || ids.has(target)) return;
      if (ids.has(prefix + target)) {
        node.properties!.href = `#${prefix}${target}`;
      }
    });
  };
}
